
/***
 * Plugin to manage do / redo not use yet
 */
class UndoRedoHistory {
  store;
  history = [];
  currentIndex = -1;
  ignoreMutations = [];

  init (store) {
    this.store = store
  }

  constructor (ignoreMutations) {
    this.ignoreMutations = ignoreMutations
  }

  addState (state, mutationType) {
    if (this.ignoreMutations.includes(mutationType) || !mutationType) {
      return
    }

    // may be we have to remove redo steps
    if (this.currentIndex + 1 < this.history.length) {
      this.history.splice(++this.currentIndex)
    }
    this.history.push(state)
    this.currentIndex++
  }

  saveSnapshot () {
    if (this.currentIndex === -1) {
      this.history.push(this.store.state)
      this.currentIndex++
    }
  }

  undo () {
    if (this.currentIndex > 0) {
      alert('Set history of index ' + (this.currentIndex - 1))
      const prevState = this.history[this.currentIndex - 1]
      // take a copy of the history state
      // because it would be changed during store mutations
      // what would corrupt the undo-redo-history
      // (same on redo)
      this.store.replaceState(this.cloneDeep(prevState))
      this.currentIndex--
    }
  }

  redo () {
    if (this.currentIndex + 1 < this.history.length) {
      const nextState = this.history[this.currentIndex + 1]
      this.store.replaceState(this.cloneDeep(nextState))
      this.currentIndex++
    }
  }

  cloneDeep (obj) {
    return JSON.parse(JSON.stringify(obj))
  }
}

export const undoRedoHistory = new UndoRedoHistory(['REQUEST_ALL_PODS', 'REQUEST_ROUTES', 'SET_PLANNINGS'])
